<template>
<!-- 年度經費核銷總表 -->
    <VCard class="pa-2">
    <v-row class="my-1">
      <v-col cols="12">
        <v-select v-model="selectedAssociation" :items="associations" item-title="1"  item-value="0" label="協會"></v-select>
      </v-col>
      <v-col cols="12">
        <v-select :disabled="selectedAssociation==null" v-model="selectedYear" no-data-text="此協會無申請" item-title="rocYear"  item-value="adYear" :items="years" label="所屬年度"></v-select>
      </v-col>
      <v-col cols="12" class="d-flex justify-end">
        <!-- <v-btn @click="search" color="primary">查詢</v-btn> -->
        <v-btn @click="exportSummary" :loading="buttonStatus.buttonLoading" :disabled="!selectedAssociation||!selectedYear" color="primary" class="ml-2">
          匯出
          <v-tooltip activator="parent">
          下載 {{selectedYear-1911}}年度 {{getAssociationName(selectedAssociation)}} 經費核銷總表
          </v-tooltip>
        </v-btn>
      </v-col>
    </v-row>
    </VCard>
</template>

<script setup lang="ts">
import { reactive } from "vue"
definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'ANNUALEXPENSESUMMARY', //系統代碼(系統授權設定中的系統代碼)
  },
})
const fileUrl = useStorage("drFsUrl").value;
const selectedAssociation=ref(null)
const selectedYear=ref(null)
const selectedExpenseItem=ref(null)
// const associations=reactive(['射箭', '游泳', '田徑'])
const years=reactive([])
const expenseItems=reactive(['奧林匹克運動會經費申請', '亞運射箭經費需求申請', 'XXX黃金計畫經費需求申請'])
const headers=reactive( [
  { title: '申請單號', value: 'applicationNumber' },
  { title: '單位', value: 'unit' },
  { title: '經費申請名稱', value: 'expenseName' },
  { title: '項目名稱', value: 'projectName' },
  { title: '申請日期', value: 'applicationDate' }
])
const items=reactive([
  { applicationNumber: 'A0001', unit: '射箭', expenseName: '奧林匹克射箭經費需求申請', projectName: '奧林匹克運動會經費申請', applicationDate: '2024/04/16 11:07:54' },
  { applicationNumber: 'A0002', unit: '射箭', expenseName: '亞運射箭經費需求申請', projectName: '名古屋亞運經費申請', applicationDate: '2024/04/12 16:00:25' },
  { applicationNumber: 'A0003', unit: '射箭', expenseName: 'XXX黃金計畫經費需求申請', projectName: '黃金計畫經費申請項目', applicationDate: '2024/04/12 13:16:33' }
])
const page=ref(1)
const pageCount=ref(1)

const buttonStatus = reactive({
   buttonLoading: false
});

const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}

const { data: getDeptSelectData, execute: getDeptSelect } = await useApi<any>(createUrl('/tca/annualexpensesummary/getDeptSelect', {
  query: {},
}))

const associations = computed(()=>getDeptSelectData.value.data)

const getAssociationName =(associationKey)=>{
  if(associationKey){
    return associations.value.find((it) => it["0"] === associationKey)?.["1"];
  }else{
    return null
  }
}
const getYearSelect= async () => {
  buttonStatus.buttonLoading = true;
  selectedYear.value=null
  try {
    const apiUrl='/tca/annualexpensesummary/getYearSelect'
    await $api(apiUrl, {
      method: 'GET',
      query:{
        deptNo:selectedAssociation.value,
      },
    }).then((response) => {
      years.splice(0 , years.length , ...response.data)
    });
  } catch (error) {
    years.length = 0;
  } finally{
    buttonStatus.buttonLoading = false;
  }
};

const exportSummary= async () => {
  buttonStatus.buttonLoading = true;
  try {
    const apiUrl='/tca/annualexpensesummary/export'
    await $api(apiUrl, {
      method: 'GET',
      query:{
        deptNo:selectedAssociation.value,
        belongYear:selectedYear.value,
      },
    }).then(async(response) => {
      if(!response?.data?.fileId){
        throw new Error('File ID is undefined');
      }
      const url = await mapFileDownload(fileUrl, response.data.fileId)
      window.open(url,'_blank');
      // buttonStatus.buttonLoading = false;
    });
  } catch (error) {
    popSwal('error','下載經費核銷總表 失敗',error)
  } finally{
    buttonStatus.buttonLoading = false;
  }
};

watch(()=>selectedAssociation.value,()=>{
  console.log('selectedAssociation watch')
  if(selectedAssociation.value){
    getYearSelect()
  }
})
</script>

<style scoped>
.ml-2 {
  margin-left: 8px;
}
</style>
